<template>
  <form
      @submit.prevent="submitCode"
      autocomplete="off"
      class="w-full max-h-screen bg-background flex flex-col relative"
      :class="{ 'overflow-y-hidden': isBusy }"
  >
    <div v-show="isBusy" class="absolute inset-0 bg-faint-white flex items-center justify-center z-10">
      <spinner :color="'text-black'" :size="10" />
    </div>

    <page-header title="Update Code" :info="code.code_id" back-to="codes">
      <button
          @click="saveCode"
          type="button"
          class="flex items-center bg-blue-200 border hover:bg-blue-300 border-blue-400 hover:border-blue-500 hover:shadow active:shadow-inner transition duration-300 text-secondary rounded-md px-2 py-1"
      >
        <svg
            class="stroke-current h-5 w-5 mr-2"
            fill="none"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            viewBox="0 0 24 24"
        >
          <path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" />
          <path d="M17 21v-8H7v8M7 3v5h8" />
        </svg>
        <span>Save</span>
      </button>
    </page-header>

    <main class="p-6 bg-background flex-1 overflow-y-scroll">
      <div class="w-full bg-white mt-6 p-5 pt-1 rounded shadow-md relative">
        <div class="mt-6">
          <div class="flex items-center mb-5">
            <h3 class="uppercase text-lg font-semibold text-primary tracking-wide">Code Summary</h3>
            <hr class="flex-1 border-primary ml-4" />
          </div>

          <div class="flex flex-wrap -my-3 -mx-5">
            <div class="w-full flex flex-col mt-3">
              <div class="flex flex-wrap">
                <div class="w-full sm:w-1/2 lg:w-1/3 flex flex-col px-5 mb-3">
                  <label class="uppercase font-semibold text-sm">CODE ID</label>
                  <input v-model="code.code_id" class="bge-input bge-input-spacing rounded" type="text" disabled />
                </div>

                <div class="w-full sm:w-1/2 lg:w-1/3 flex flex-col px-5 mb-3">
                  <label class="uppercase font-semibold text-sm">TYPE</label>
                  <input v-model="code.type" class="bge-input bge-input-spacing rounded" type="text" disabled />
                </div>

                <div class="w-full sm:w-1/2 lg:w-1/3 flex flex-col px-5 mb-3">
                  <label class="uppercase font-semibold text-sm">STATUS</label>
                  <input v-model="code.status" class="bge-input bge-input-spacing rounded" type="text" disabled />
                </div>
              </div>
            </div>

            <div class="w-full flex flex-col">
              <div class="flex flex-wrap">
                <div class="w-full sm:w-1/2 lg:w-1/3 flex flex-col px-5 mb-3">
                  <label class="uppercase font-semibold text-sm">DISTRIBUTOR</label>
                  <input v-model="code.distributor_name" class="bge-input bge-input-spacing rounded" type="text" disabled />
                </div>

                <div class="w-full sm:w-1/2 lg:w-1/3 flex flex-col px-5 mb-3">
                  <label class="uppercase font-semibold text-sm">ENGINEER</label>
                  <input v-model="code.engineer_name" class="bge-input bge-input-spacing rounded" type="text" disabled />
                </div>

                <div class="w-full sm:w-1/2 lg:w-1/3 flex flex-col px-5 mb-3">
                  <label class="uppercase font-semibold text-sm">SOFTWARE VERSION</label>
                  <input v-model="code.software_version" class="bge-input bge-input-spacing rounded" type="text" disabled />
                </div>
              </div>
            </div>

            <div class="w-full flex flex-col">
              <div class="flex flex-wrap">
                <div class="w-full sm:w-1/2 lg:w-1/3 flex flex-col px-5 mb-3">
                  <label class="uppercase font-semibold text-sm">CHALLENGE CODE</label>
                  <input v-model="code.challenge_code" class="bge-input bge-input-spacing rounded" type="text" disabled />
                </div>

                <div class="w-full sm:w-1/2 lg:w-1/3 flex flex-col px-5 mb-3">
                  <label class="uppercase font-semibold text-sm">RETURN CODE</label>
                  <input v-model="code.return_code" class="bge-input bge-input-spacing rounded" type="text" disabled />
                </div>

                <div class="w-full sm:w-1/2 lg:w-1/3 flex flex-col px-5 mb-3">
                  <label class="uppercase font-semibold text-sm"></label>

                  <div class="mt-6 w-full">
                    <div class="inline-flex items-center">
                      <Toggle
                          class="mr-2"
                          label="Chargeable"
                          :checked="code.chargeable === true"
                          @value-changed="onChargeableToggle"
                          labelPosition="left"
                          labelClasses="uppercase font-semibold text-sm"
                      />
                    </div>
                  </div>
                </div>




              </div>

            </div>

          </div>
        </div>
      </div>

      <div class="w-full bg-white mt-6 p-5 pt-1 rounded shadow-md relative">
        <div class="mt-6">
          <div class="flex items-center mb-5">
            <h3 class="uppercase text-lg font-semibold text-primary tracking-wide">Add Comment</h3>
            <hr class="flex-1 border-primary ml-4" />
          </div>

          <div class="flex flex-wrap -my-3 -mx-5">
            <div class="w-full flex flex-col px-5 mb-3">
              <label class="uppercase font-semibold text-sm">COMMENT</label>
              <textarea
                  v-model="newComment"
                  class="bge-input bge-input-spacing rounded w-full mt-2"
                  rows="3"
                  placeholder="Type your comment..."
              />
              <div class="flex justify-end mt-3">
                <button
                    type="button"
                    @click="addComment"
                    class="flex items-center bg-green-200 border hover:bg-green-300 border-green-400 hover:border-green-500 hover:shadow active:shadow-inner transition duration-300 text-secondary rounded-md px-2 py-1"
                >
                  <span>Add</span>
                </button>
              </div>
            </div>
          </div>

          <div class="flex items-center mb-5 mt-8">
            <h3 class="uppercase text-lg font-semibold text-primary tracking-wide">Comments</h3>
            <hr class="flex-1 border-primary ml-4" />
          </div>

          <div v-if="sortedComments.length" class="space-y-3">
            <div
                v-for="q in sortedComments"
                :key="q.query_id"
                class="border rounded-md p-4 bg-gray-50"
            >
              <div class="flex justify-between items-start">
                <div class="text-sm font-semibold text-primary">
                  {{ q.created_by_name || q.created_by }}
                </div>
                <div class="text-xs text-gray-600">
                  {{ formatUnix(q.created_at) }}
                </div>
              </div>

              <div class="mt-2 text-sm text-gray-800 whitespace-pre-wrap">
                {{ q.message }}
              </div>
            </div>
          </div>

          <div v-else class="text-sm text-gray-600">
            No comments found.
          </div>
        </div>
      </div>

    </main>
  </form>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import Spinner from "@/components/Spinner.vue";
import Toggle from "@/components/Toggle.vue";
import notificationMixin from "@/mixins/notificationMixin";
import CodeService from "@/services/codeService";

export default {
  name: "ManageCode",
  mixins: [notificationMixin],
  components: {
    PageHeader,
    Spinner,
    Toggle,
  },
  props: {
    codeId: String,
  },
  data() {
    return {
      isBusy: false,
      code: {
        code_id: "",
        distributor_id: "",
        engineer_id: "",
        distributor_name: "",
        engineer_name: "",
        challenge_code: "",
        return_code: "",
        type: "",
        software_version: "",
        chargeable: false,
        status: "",
        queries: [],
      },
      newComment: "",
      CodeService,
    };
  },
  computed: {
    sortedComments() {
      const list = Array.isArray(this.code.queries) ? this.code.queries : [];
      return list.slice().sort((a, b) => (a.created_at || 0) - (b.created_at || 0));
    },
  },
  mounted() {
    if (this.codeId) this.loadCode();
  },
  methods: {
    toStr(v) {
      if (v === undefined || v === null) return "";
      return String(v);
    },
    formatUnix(unix) {
      if (!unix) return "";
      return this.$moment.unix(unix).format("DD/MM/YYYY HH:mm");
    },
    submitCode(event) {
      event.preventDefault();
    },
    async loadCode() {
      try {
        this.isBusy = true;
        const apiCode = await this.CodeService.getCodeById(this.codeId);
        this.code = this.mapApiToUi(apiCode);
      } catch (e) {
        this.notifyError("Failed to load code.");
      } finally {
        this.isBusy = false;
      }
    },
    onChargeableToggle(value) {
      if (value === true) {
        this.code.chargeable = true;
        return;
      }
      this.code.chargeable = false;
    },
    mapApiToUi(apiCode) {
      const c = apiCode || {};
      return {
        code_id: this.toStr(c.code_id),
        distributor_id: this.toStr(c.distributor_id),
        engineer_id: this.toStr(c.engineer_id),
        distributor_name: this.toStr(c.distributor_name),
        engineer_name: this.toStr(c.engineer_name),
        challenge_code: this.toStr(c.challenge_code),
        return_code: this.toStr(c.return_code),
        type: this.toStr(c.type),
        software_version: this.toStr(c.software_version),
        chargeable: !!c.chargeable,
        status: this.toStr(c.status),
        queries: Array.isArray(c.queries) ? c.queries : [],
      };
    },
    mapUiToUpdatePayload() {
      return {
        chargeable: this.code.chargeable === true,
      };
    },
    async saveCode() {
      try {
        this.isBusy = true;
        const payload = this.mapUiToUpdatePayload();
        await this.CodeService.updateCode(this.codeId, payload);
        await this.loadCode();
        this.notifySuccess("Code updated successfully");
      } catch (e) {
        this.notifyError("Failed to save code");
      } finally {
        this.isBusy = false;
      }
    },
    async addComment() {
      try {
        const msg = this.toStr(this.newComment).trim();
        if (!msg) {
          this.notifyWarning("Please enter a comment.");
          return;
        }

        const u = (this.$store && this.$store.state && this.$store.state.user) ? this.$store.state.user : null;

        const createdBy = u && u.staff_id ? this.toStr(u.staff_id) : "";
        const createdByName = u ? ((this.toStr(u.first_name).trim() + " " + this.toStr(u.last_name).trim()).trim()) : "";

        const payload = {
          message: msg,
          created_by: createdBy,
          created_by_name: createdByName,
        };

        this.isBusy = true;
        await this.CodeService.createCodeQuery(this.codeId, payload);
        this.newComment = "";
        await this.loadCode();
        this.notifySuccess("Comment added.");
      } catch (e) {
        this.notifyError("Failed to add comment.");
      } finally {
        this.isBusy = false;
      }
    },
  },
};
</script>
